import { render, staticRenderFns } from "./AppDraggable.vue?vue&type=template&id=433f94d2&"
import script from "./AppDraggable.vue?vue&type=script&lang=js&"
export * from "./AppDraggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports